import ProductModal from './ProductModal'

export default class DetailProductModal extends ProductModal {
    constructor(element) {
        super(element)
        this.ref.closeButtons = []
    }

    close() {
        this.ref.background.click()
        super.close()
    }
}
